export enum IEtaExportField {
  TaskName = 'taskName',
  Description = 'description',
  ExpectedEta = 'expectedEta',
  ActualEta = 'actualEta',
  Status = 'status',
}
